import { createStyles } from '@/contexts/theme-context';
import { DropdownMenu } from '@usepepper/ui/molecules/dropdown-menu';
import { DropdownTrigger } from '@usepepper/ui/drafts/dropdown-trigger';
import { memo, useMemo, useState } from 'react';
import { OrderGuideCollectionData } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/blocs/loaders/sales-portal-order-guide-collections-loader';
import { Typography } from '@usepepper/ui/atoms/typography';

const SELECTOR_WIDTH = 176;

interface OrderGuideSelectorProps {
  listData: OrderGuideCollectionData[];
  onSelectItem: (item: OrderGuideCollectionData) => void;
  selectedItem: OrderGuideCollectionData | null;
}

export const OrderGuideSelector: React.FC<OrderGuideSelectorProps> = memo(
  ({ listData, onSelectItem, selectedItem }) => {
    const [styles, theme] = useStyles();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const dropdownListData = useMemo(
      () =>
        listData.map((orderGuide) => ({
          key: orderGuide.uuid,
          label: orderGuide.displayName,
          onPress: () => {
            setIsDropdownOpen(false);
            onSelectItem(orderGuide);
          },
        })),
      [listData, onSelectItem],
    );

    const displayText = selectedItem?.displayName ?? '';

    return (
      <DropdownMenu
        containerStyle={styles.dropdownContainer}
        isVisible={isDropdownOpen}
        listData={dropdownListData}
        onClose={() => setIsDropdownOpen(false)}
        position="bottom-start"
        trigger={
          <DropdownTrigger
            isOpen={isDropdownOpen}
            onPress={() => setIsDropdownOpen(true)}
            style={styles.trigger}
          >
            <Typography
              color={theme.sk.color.text.primary}
              flexShrink={1}
              numberOfLines={1}
              variant="paragraph-md"
            >
              {displayText}
            </Typography>
          </DropdownTrigger>
        }
      />
    );
  },
);

const useStyles = createStyles(() => ({
  dropdownContainer: {
    minWidth: SELECTOR_WIDTH,
  },
  trigger: {
    height: 40,
    width: SELECTOR_WIDTH,
  },
}));
